module.exports = __webpack_public_path__ + "static/img/share_my.0c615e50.svg";